import React, { Component } from 'react';
import Editor from '../../common/Quill';
import { getQuestionTypes, updateQuestion, getQuestion } from '../../../services/formService';
import { toast, ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { QuestionTypes, WidgetTypes } from '../../../constants/QuestionTypes';
import { stripPTag, checkImgSize, stripTags } from '../../common/commonFuncs';
import TypeVideo from './question_types/Video_Type';
import TypeMultiChoice from './question_types/MultipleChoice_Type';
import TypeMatrix from './question_types/Matrix_Type';
import TypeScale from './question_types/Scale_Type';
import TypeNumeric from './question_types/Numeric_Type';
import TypePicklist from './question_types/Picklist_Type';
import TypeDropdown from './question_types/Dropdown_Type';
import { TextField } from '@material-ui/core';
import { logActivity } from '../../../services/utilService';
import TypeInstitution from "./question_types/Institution_Type";
import moment from 'moment';
import QAFooter from "./question_types/QAFooter";
import * as Icon from "react-feather";
import CustomTooltip from '../../common/CustomTooltip';
import { getProjectForms } from "../../../services/projectService";
import { getFormWidgetQuestionsAnswers, getFormWidgets } from '../../../services/formService';

class WQuestionAnswer extends Component {
	Question_types = [];

	state = {
		Project_ID: this.props.Project_ID,
		Widget_ID: this.props.Widget.Widget_ID,
		Question_ID: 0,
		Question_Type_ID: parseInt(this.props.Question_Type_ID),
		Question_Text: '',
		Description: '',
		Indicate_Response: false,
		Response_Required: false,
		Align_Horizontal: false,
		loading: true,
		canChangeType: false,
		Allow_Multiple_Selection: false,
		Custom_Render: null,
		reportVblName: null,
		Valid_Date_From: null,
		Valid_Date_FromDate: null,
		Valid_Date_To: null,
		Valid_Date_ToDate: null,
		Valid_Date_MinAge: null,
		Valid_Date_MaxAge: null,
		Valid_Date_Placeholder: '',
		WithinRow: false,
		remapResponses: true,
		Allow_Leading_Zero: false,
		WithinRowChanged: false,
    	Prepopulate_Today_Date: false,
		Is_Subquestion: false,
		Parent_Question_Widget_ID: 0, 
		Form_QA_Widgets: [],
		Form_ID: this.props.Form_ID,
		Hide: false,
		Project_Forms: [],
		All_Form_QA_Widgets: {},
		Prepopulate_Response: false,
		Prepopulate_Response_Form_ID: 0,
		Prepopulate_Response_Widget_ID: 0,
		Prevent_Save_Invalid: false
	};

	constructor(props) {
		super(props);
		this.handleSave = this.handleSave.bind(this);
		this.handleWithinRowChange = this.handleWithinRowChange.bind(this);
		this.passDown = this.passDown.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
	}

	async componentDidMount() {
		this.setState({ loading: true });

		const Form_QA_Widgets = this.props.Form_Widgets.filter((w) => w.Widget_Type_ID === 2)
		this.setState({ Form_QA_Widgets })

		const { data: qTypes } = await getQuestionTypes();
		this.Question_types = qTypes.filter((type) => type.Question_Type_ID !== 8);

		// For rich text editor's link config
		const input = document.querySelector('input[data-link]');
		if (input) {
			input.dataset.link = '';
			input.placeholder = '';
		}

		const { data } = await getQuestion(this.props.Widget.Widget_ID);
		if (data.length > 0) {
			//console.log('data', data[0]);
			this.setState({ Question_ID: data[0].Question_ID });
			this.setState({ Question_Type_ID: data[0].Question_Type_ID });
			this.setState({ Question_Text: data[0].Question_Text });
			this.setState({ Description: data[0].Description });
			this.setState({ Response_Required: data[0].Response_Required });
			this.setState({ Indicate_Response: data[0].Indicate_Response });
			this.setState({ Align_Horizontal: data[0].Align_Horizontal });
			this.setState({ Allow_Multiple_Selection: data[0].Allow_Multiple_Selection })
			this.setState({ Custom_Render: data[0].Custom_Render })
			this.setState({ reportVblName: data[0].Report_VariableName });
			this.setState({ Valid_Condition: data[0].Valid_Condition ? JSON.parse(data[0].Valid_Condition) : [] });
			this.setState({ Allow_Leading_Zero:  data[0].Allow_Leading_Zero ? data[0].Allow_Leading_Zero : false})
      		this.setState({ Prepopulate_Today_Date: data[0].Prepopulate_Today_Date ? data[0].Prepopulate_Today_Date : false})
			this.setState({ Is_Subquestion: data[0].Parent_Question_Widget_ID ? true : false})
			this.setState({ Parent_Question_Widget_ID: data[0].Parent_Question_Widget_ID ? data[0].Parent_Question_Widget_ID : 0})
			this.setState({ Hide: data[0].Hide ? true: false })
			this.setState({ Prepopulate_Response: data[0].Prepopulate_Response_Widget_ID && data[0].Prepopulate_Response_Widget_ID > 0 ? true : false})
			this.setState({ Prepopulate_Response_Form_ID: data[0].Prepopulate_Response_Form_ID ? data[0].Prepopulate_Response_Form_ID : 0})
			this.setState({ Prepopulate_Response_Widget_ID: data[0].Prepopulate_Response_Widget_ID ? data[0].Prepopulate_Response_Widget_ID : 0})
			this.setState({ Prevent_Save_Invalid: data[0].Prevent_Save_Invalid ?? false });
		} else {
			this.setState({ canChangeType: true });
		}

		//Set Include in Row Widget data
		this.setState({ WithinRow: this.props.Widget.WithinRow ? this.props.Widget.WithinRow : false})
		if (this.state.Question_Type_ID === QuestionTypes.Date && this.state.Valid_Condition) {
			let state = this.state.Valid_Condition;
			console.log('Valid_Condition', state);
			this.setState({
				Valid_Date_From: state.Date_From,
				Valid_Date_FromDate: moment(state.Date_FromDate).format('YYYY-MM-DD'),
				Valid_Date_To: state.Date_To,
				Valid_Date_ToDate: moment(state.Date_ToDate).format('YYYY-MM-DD'),
				Valid_Date_MinAge: state.Date_MinAge,
				Valid_Date_MaxAge: state.Date_MaxAge,
				Valid_Date_Placeholder: state.Date_Placeholder? moment(state.Date_Placeholder).format('YYYY-MM-DD') : ''
			});
		}

		let { data: Forms } = await getProjectForms(this.props.Project_ID)
        this.setState({ Project_Forms: Forms})

		if (this.state.Prepopulate_Response_Form_ID > 0) {
			const { data } = await getFormWidgets(parseInt(this.state.Prepopulate_Response_Form_ID), true)
			let Form_QA_Widgets = data.filter(widget => widget.Widget_Type_ID === WidgetTypes.QA)
			let All_Form_QA_Widgets = this.state.All_Form_QA_Widgets
			All_Form_QA_Widgets[this.state.Prepopulate_Response_Form_ID] = Form_QA_Widgets
			this.setState(All_Form_QA_Widgets)
		}
		
		this.setState({ loading: false });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.Form_Widgets !== this.props.Form_Widgets) {
			const Form_QA_Widgets = this.props.Form_Widgets.filter((w) => w.Widget_Type_ID === 2)
			this.setState({ Form_QA_Widgets })
		}
	}

	handleAllowMultipleSelection = (Allow_Multiple_Selection) => {
		this.setState({ Allow_Multiple_Selection });
	};

	handleWithinRowChange() {
		this.setState({ WithinRow: !this.state.WithinRow, WithinRowChanged: true })
	}

	handleChange = (input) => {
		let value = input.value;
		if (input.name.includes('ID')) {
			value = parseInt(value);
		} 
		else if ((input.name === 'Valid_Date_From' || input.name === 'Valid_Date_To') && input.value === '-1') {
			this.setState({ [input.name + 'Date']: null });
		}
		else if (input.name.includes('Age') && value==='') {
			value = null;
		}
		else {
			if (!checkImgSize(value)) {
				toaster('error', 'File size cannot exceed 1MB. Please resize the image.', { position: toast.POSITION.TOP_CENTER });
				value = this.state[input.name];
			}
		}
		this.setState({ [input.name]: value });
		//console.log('min', this.state)
	};

	handleSave = async (Question_Answers = null) => {
		let state = this.state;
		const Question_Text = stripPTag(state.Question_Text);
		this.setState({ Question_Text });

		/* Check valid conditions */
		if (state.Question_Type_ID === QuestionTypes.Date) {
			let Valid_Condition = {
				Date_From: state.Valid_Date_From,
				Date_FromDate: state.Valid_Date_FromDate,
				Date_To: state.Valid_Date_To,
				Date_ToDate: state.Valid_Date_ToDate,
				Date_MinAge: state.Valid_Date_MinAge,
				Date_MaxAge: state.Valid_Date_MaxAge,
				Date_Placeholder: state.Valid_Date_Placeholder
			}
			this.setState({ Valid_Condition });
			let currentDate = moment(new Date()).format('YYYY/MM/DD');

			if (Valid_Condition['Date_From'] !== null && Valid_Condition['Date_From'] !== '-1') {
				Valid_Condition['Date_FromDate'] = (Valid_Condition['Date_From'] === 'current') ? currentDate :
					moment(Valid_Condition['Date_FromDate']).format('YYYY/MM/DD');
			}
			if (Valid_Condition['Date_To'] !== null && Valid_Condition['Date_To'] !== '-1') {
				Valid_Condition['Date_ToDate'] = (Valid_Condition['Date_To'] === 'current') ? currentDate :
					moment(Valid_Condition['Date_ToDate']).format('YYYY/MM/DD');
			}
			Valid_Condition['Date_Placeholder'] = Valid_Condition['Date_Placeholder'] === '' ? null :
				moment(Valid_Condition['Date_Placeholder']).format('YYYY/MM/DD');

			(((Valid_Condition['Date_From'] !== null) && (Valid_Condition['Date_To'] !== null) &&
				(Valid_Condition['Date_FromDate'] > Valid_Condition['Date_ToDate'])) ||
				((Valid_Condition['Date_MinAge'] !== null) && (Valid_Condition['Date_MaxAge'] !== null) &&
					(parseInt(Valid_Condition['Date_MaxAge']) < parseInt(Valid_Condition['Date_MinAge'])))) &&
				toaster('error', 'Please enter valid conditions!');
			state.Valid_Condition = Valid_Condition
		}

		/* Save Question Config */
		const { data } = await updateQuestion(this.state.Question_Text, Question_Answers, state);
		if (data.includes('Error')) {
			toaster('error', data);
			logActivity('/formBuilder', 'WIDGET_QUES_SAVE_FAILED');
			return 0;
		} else {
			const Question_ID = data.split(':').pop();
			this.setState({ Question_ID });
			this.setState({ canChangeType: false });
			toaster('success', 'Question saved.');
			logActivity('/formBuilder', 'WIDGET_QUES_SAVE_SUCCESS');
			if (this.state.WithinRow || this.state.WithinRowChanged) {
				this.props.refreshRowWidget()
			}
			this.setState({ WithinRowChanged: false })
			return Question_ID;
		}
	};

	handleTypeChange = (type) => {
		this.setState({ Question_Type_ID: type });
	};

	handleRemove() {
		this.props.onRemove(this.props.Widget.Widget_ID);
	}

	handleSwitch = ({ target }) => {
		let name = target.name;
		this.setState({ [name]: !this.state[name] });
	};

	handleCanChangeType = () => {
		this.setState({ canChangeType: false });
	};

	setRemapResponses = (value) => {
		this.setState({remapResponses: value});
	}

	handleAllowLeadingZeroChange = (value) => {
		this.setState({Allow_Leading_Zero: value})
	}

	handlePrepopulateTodatDateChange = () => {
		this.setState({ Prepopulate_Today_Date: !this.state.Prepopulate_Today_Date})
	}

	handleIsSubquestionChange = () => {
		if (this.state.Is_Subquestion) {
			this.setState({ Parent_Question_Widget_ID: 0 })
		}
		this.setState({ Is_Subquestion: !this.state.Is_Subquestion })
	}

	handleParentQuestionSelection = (Widget_ID) => {
		this.setState({ Parent_Question_Widget_ID: Widget_ID })
	}

	handleHideChange = () => {
		this.setState({ Hide: !this.state.Hide })
	}

	handlePrepopulateResponseChange = () => {
		this.setState({ Prepopulate_Response: !this.state.Prepopulate_Response })
	}

	handlePrepopulateResponseFormSelection = async (Form_ID) => {
		const { data } = await getFormWidgets(parseInt(Form_ID), true)
		let Form_QA_Widgets = data.filter(widget => widget.Widget_Type_ID === WidgetTypes.QA)
		let All_Form_QA_Widgets = this.state.All_Form_QA_Widgets
		All_Form_QA_Widgets[Form_ID] = Form_QA_Widgets
		this.setState(All_Form_QA_Widgets)
		this.setState({ Prepopulate_Response_Form_ID: parseInt(Form_ID) })
	}

	handlePrepopulateResponseWidgetSelection = (Widget_ID) => {
		this.setState({ Prepopulate_Response_Widget_ID: Widget_ID })
	}

	handlePreventSaveInvalidChange = () => {
		this.setState({ Prevent_Save_Invalid: !this.state.Prevent_Save_Invalid });
	}

	passDown = () => {
		const {
			Question_Text,
			Description,
			Align_Horizontal,
			Response_Required,
			Indicate_Response,
			Custom_Render,
			remapResponses,
		} = this.state;

		return {
			Question_Text: stripPTag(Question_Text),
			Description: Description,
			Custom_Render: Custom_Render,
			Response_Required: Response_Required,
			Align_Horizontal: Align_Horizontal,
			Indicate_Response: Indicate_Response,
			remapResponses: remapResponses
		};
	};
	render() {
		const {
			Project_ID,
			Form_ID,
			Widget_ID,
			Question_ID,
			Question_Type_ID,
			Question_Text,
			Response_Required,
			Indicate_Response,
			Align_Horizontal,
			Description,
			WithinRow,
			Custom_Render,
			reportVblName,
			Valid_Date_From,
			Valid_Date_FromDate,
			Valid_Date_To,
			Valid_Date_ToDate,
			Valid_Date_MinAge,
			Valid_Date_MaxAge,
			Valid_Date_Placeholder,
			remapResponses,
			Hide,
			Project_Forms,
			All_Form_QA_Widgets,
			Prepopulate_Response,
			Prepopulate_Response_Form_ID,
			Prepopulate_Response_Widget_ID
		} = this.state;

		if (this.state.loading) return <div className='center'>Loading...</div>;

		return (
			<React.Fragment>
				{Question_Type_ID !== QuestionTypes.Video && Question_Type_ID !== QuestionTypes.Info && (
					<div className='d-flex justify-content-between'>
						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'indicateSwitch' + Widget_ID}
								type='checkbox'
								name='Indicate_Response'
								checked={Indicate_Response}
								value={Indicate_Response}
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'indicateSwitch' + Widget_ID}>
								Indicate Response
							</label>
						</div>

						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'horizontalSwitch' + Widget_ID}
								type='checkbox'
								checked={Align_Horizontal}
								value={Align_Horizontal}
								name='Align_Horizontal'
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'horizontalSwitch' + Widget_ID}>
								Inline Alignment
							</label>
						</div>

						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'requiredSwitch' + Widget_ID}
								type='checkbox'
								checked={Response_Required}
								value={Response_Required}
								name='Response_Required'
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'requiredSwitch' + Widget_ID}>
								Response Required
							</label>
						</div>
						{/* Add include in row Widget here */}
						<div className="custom-control custom-switch mt-n2">
							<input
								type="checkbox"
								className="custom-control-input"
								checked={WithinRow}
								value={WithinRow}
								onChange={this.handleWithinRowChange}
								name='Include_RowWidget'
								id={Question_ID + 'rowSwitch' + Widget_ID}
							/>
							<label htmlFor={Question_ID + 'rowSwitch' + Widget_ID} className="custom-control-label">
								Include in row widget
							</label>
						</div>

						<div className="custom-control custom-switch mt-n2">
							<input
								type="checkbox"
								className="custom-control-input"
								checked={Hide}
								value={Hide}
								onChange={this.handleHideChange}
								name='Hide'
								id={Question_ID + 'hideSwitch' + Widget_ID}
							/>
							<label htmlFor={Question_ID + 'hideSwitch' + Widget_ID} className="custom-control-label">
								Hide
							</label>
						</div>
					</div>
				)}
				{this.state.canChangeType && (
					<div className='form-group'>
						<select className='custom-select' value={Question_Type_ID} name='Question_Type_ID' onChange={(e) => this.handleChange(e.target)}>
							<option>Select Question Type</option>
							{this.Question_types.map((type) => {
								return (
									<option key={type.Question_Type_ID} value={type.Question_Type_ID}>
										{type.Question_Type}
									</option>
								);
							})}
						</select>
					</div>
				)}

				<div className='form-check mt-3 mb-3'>
					<input type='checkbox' className='form-check-input' id='Is_Subquestion' name='Is_Subquestion' checked={this.state.Is_Subquestion} onChange={this.handleIsSubquestionChange} />
					<label htmlFor='Is_Subquestion' className='form-check-label'>
					Is Subquestion?
					</label>
					<CustomTooltip title="Select this config to assign it as another question's subquestion" placement='right' className="text-muted pl-1 d-inline">
						<Icon.Info size={20}/>
					</CustomTooltip>
					{this.state.Is_Subquestion && 
						<div>
							<p className='mt-1 mb-0'>Please choose parent question from below:</p>
							<div className="input-group input-group-joined mr-1">
								<select
									name={Widget_ID}
									key={Widget_ID}
									value={this.state.Parent_Question_Widget_ID}
									className="form-control"
									onChange={(e) => this.handleParentQuestionSelection(e.target.value)}
								>
								<option value="0"> - Select -</option>
								{this.state.Form_QA_Widgets.map((option) => (
									option.Widget_ID !== Widget_ID &&
									<option value={option.Widget_ID}>
										Widget #{option.Widget_ID}: {option.Question_Text ? stripTags(option.Question_Text) : ''}
									</option>
								))}
								</select>
							</div>
						</div>
						}
				</div>

				{(Question_Type_ID === QuestionTypes.Text || Question_Type_ID === QuestionTypes.Textarea ||
					Question_Type_ID === QuestionTypes.Time || Question_Type_ID === QuestionTypes.Date ||
					Question_Type_ID === QuestionTypes.Multiple_Choice || Question_Type_ID === QuestionTypes.Checkbox ||
					Question_Type_ID === QuestionTypes.Picklist || Question_Type_ID === QuestionTypes.Numeric) && 
					<div className='form-check mt-3 mb-3'>
						<input type='checkbox' className='form-check-input' id='Prepopulate_Response' name='Prepopulate_Response' checked={this.state.Prepopulate_Response} onChange={this.handlePrepopulateResponseChange} />
						<label htmlFor='Prepopulate_Response' className='form-check-label'>
						Prepopulate Response?
						</label>
						<CustomTooltip title="Select this config to prepopulate the response with another question widget" placement='right' className="text-muted pl-1 d-inline">
							<Icon.Info size={20}/>
						</CustomTooltip>
						{Prepopulate_Response && 
							<div>
								<p className='mt-1 mb-0'>Please choose a project form and a widget to prepopulate response from below:</p>
								<div className="d-flex justify-content-between">
									<div className="input-group input-group-joined mr-1">
										<select
											name="Prepopulate_Response_Form_ID"
											key="Prepopulate_Response_Form_ID"
											value={Prepopulate_Response_Form_ID}
											className="form-control"
											onChange={(e) => this.handlePrepopulateResponseFormSelection(e.target.value)}
										>
										<option value="0">Please select a form...</option>
										{Project_Forms.map((option) => (
											parseInt(option.Form_ID) !== parseInt(Form_ID) &&
											<option value={option.Form_ID}>
												Form #{option.Form_ID}: {option.Form_Name ? stripTags(option.Form_Name) : ''}
											</option>
										))}
										</select>
									</div>
									{Prepopulate_Response_Form_ID > 0 && <div className="input-group input-group-joined mr-1">
										<select
											name="Prepopulate_Response_Widget_ID"
											key="Prepopulate_Response_Widget_ID"
											value={Prepopulate_Response_Widget_ID}
											className="form-control"
											onChange={(e) => this.handlePrepopulateResponseWidgetSelection(e.target.value)}
										>
										<option value="0">Please select a widget...</option>
										{All_Form_QA_Widgets[Prepopulate_Response_Form_ID].map((option) => (
											(option.Widget_ID !== Widget_ID && option.Question_Type_ID === Question_Type_ID) &&
											<option value={option.Widget_ID}>
												Widget #{option.Widget_ID}: {option.Question_Text ? stripTags(option.Question_Text) : ''}
											</option>
										))}
										</select>
									</div>}
								</div>
							</div>
							}
					</div>}

				<div className='form-group'>
					<label htmlFor='Question_Text'>Question Text</label>
					<Editor
						value={Question_Text}
						onChange={(value) =>
							this.handleChange({
								value: value,
								name: 'Question_Text',
							})
						}
					/>
				</div>
				<div className='form-group'>
					<TextField
						id={Question_ID + 'Description'}
						label='Question Description'
						multiline
						fullWidth
						maxRows={2}
						value={Description}
						name='Description'
						variant='outlined'
						onChange={(e) => this.handleChange(e.target)}
					/>
				</div>
				
				{(Question_Type_ID !== QuestionTypes.Matrix) && (
					<div className='form-group'>
						<TextField
							id={Question_ID + 'reportVblName'}
							label='Reporting Field Name'
							fullWidth
							maxRows={2}
							value={reportVblName}
							name='reportVblName'
							variant='outlined'
							onChange={(e) => this.handleChange(e.target)}
						/>
					</div>
				)}

				{/* Validation fields for Date Type Questions */}
				{(Question_Type_ID === QuestionTypes.Date) && (
					<div className="form-group">
						<label >Valid Date Range</label>
						<div className='form-group row'>
							<div className='col-sm-2'>
								<label htmlFor='valid_FromDate'>From</label>
								<select className='form-control' name='Valid_Date_From' id='Valid_Date_From' onChange={(e) => this.handleChange(e.target)} value={Valid_Date_From}>
									<option value={-1}>- Select -</option>
									<option value={'current'}>Current Date</option>
									<option value={'other'}>Other</option>
								</select>
							</div>
							<div className='col-sm-2'>
								<label htmlFor='valid_ToDate'>To</label>
								<select className='form-control' name='Valid_Date_To' id='Valid_Date_To' onChange={(e) => this.handleChange(e.target)} value={Valid_Date_To}>
									<option value={-1}>- Select -</option>
									<option value={'current'}>Current Date</option>
									<option value={'other'}>Other</option>
								</select>
							</div>
							<div className='col-sm-3'>
								<label htmlFor='valid_ToDate'>If Age related, Min Age</label>
								<input key={'minAge' + Widget_ID} type='number' name='Valid_Date_MinAge' id='Valid_Date_MinAge' className='form-control' value={Valid_Date_MinAge} onChange={(e) => this.handleChange(e.target)} />
							</div>
							<div className='col-sm-2'>
								<label htmlFor='valid_ToDate'>Max Age</label>
								<input key={'maxAge' + Widget_ID} type='number' name='Valid_Date_MaxAge' id='Valid_Date_MaxAge' className='form-control' value={Valid_Date_MaxAge} onChange={(e) => this.handleChange(e.target)} />
							</div>
							<div className='col-sm-2'>
								<label htmlFor='valid_PlaceholderDate'>Placeholder Date</label>
								<input key={'placeholderDate' + Widget_ID} type='date' name='Valid_Date_Placeholder' id='Valid_Date_Placeholder' className='form-control' value={Valid_Date_Placeholder} onChange={(e) => this.handleChange(e.target)} />
							</div>
						</div>
						<div className='form-group row'>
							<div className='col-sm-2'>
								{
									Valid_Date_From === 'other' && (
										<div>
											<label htmlFor='valid_FromDate'>Date</label>
											<input key={'fromDate' + Widget_ID} type='date' name='Valid_Date_FromDate' id='Valid_Date_FromDate' className='form-control' value={Valid_Date_FromDate} onChange={(e) => this.handleChange(e.target)} />
										</div>
									)}
								</div>
							<div className='col-sm-2'>
								{
									Valid_Date_To === 'other' && (
										<div>
											<label htmlFor='valid_ToDate'>Date</label>
											<input key={'toDate' + Widget_ID} type='date' name='Valid_Date_ToDate' id='Valid_Date_ToDate' className='form-control' value={Valid_Date_ToDate} onChange={(e) => this.handleChange(e.target)} />
										</div>
									)}
									</div>
						</div>
						<div className={'form-check'}>
							<input type='checkbox' className='form-check-input' id='Prevent_Save_Invalid' name='Prevent_Save_Invalid' checked={this.state.Prevent_Save_Invalid} onChange={this.handlePreventSaveInvalidChange} />
							<label htmlFor='Prevent_Save_Invalid' className='form-check-label'>
								Prevent Save if Invalid
							</label>
							<CustomTooltip title="Do not save form and show an alert if the response is invalid" placement='right' className="text-muted pl-1 d-inline">
								<Icon.Info size={20}/>
							</CustomTooltip>
						</div>

					</div>
				)}
{/* 
				{(Question_Type_ID === QuestionTypes.Text || Question_Type_ID === QuestionTypes.Textarea) && (
					<div className="form-group">
						<label >Valid Input</label>
						<div className='form-group row'>
						</div>
					</div>
				)} */}

				<div className="form-group">
					<label>Custom Rendering</label>
					<br />
					<textarea name='Custom_Render' id='Custom_Render' className='form-control' rows={4} value={Custom_Render} onChange={(e) => this.handleChange(e.target)} placeholder='' />
				</div>

        {Question_Type_ID === QuestionTypes.Date && (
          <div className='form-check'>
            <input type='checkbox' className='form-check-input' id='Prepopulate_Today_Date' name='Prepopulate_Today_Date' checked={this.state.Prepopulate_Today_Date} onChange={this.handlePrepopulateTodatDateChange} />
            <label htmlFor='Prepopulate_Today_Date' className='form-check-label'>
              Prepopulate Today's Date
            </label>
			<CustomTooltip title="Select this config to prepopulate today's date when the form is empty" placement='right' className="text-muted pl-1 d-inline">
				<Icon.Info size={20}/>
			</CustomTooltip>
          </div>
        )}

				{/* Simple question types that requires only question text */}
				{(Question_Type_ID === QuestionTypes.Text || Question_Type_ID === QuestionTypes.Textarea ||
					Question_Type_ID === QuestionTypes.Time || Question_Type_ID === QuestionTypes.Date ||
					Question_Type_ID === QuestionTypes.Info || Question_Type_ID === QuestionTypes.Checkbox) && (
					<QAFooter
						Widget_ID={Widget_ID}
						handleSave={() => this.handleSave()}
						handleRemove={this.handleRemove}
						showRemapResponses={Question_Type_ID !== QuestionTypes.Info}
						remapResponses={remapResponses}
						setRemapResponses={this.setRemapResponses}
					/>
				)}

				{/* Numeric & Numeric Tally */}
				{(Question_Type_ID === QuestionTypes.Numeric || Question_Type_ID === QuestionTypes.Numeric_Tally) && (
					<TypeNumeric
						onSave={this.handleSave}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						onTypeChange={this.handleTypeChange}
						isTally={Question_Type_ID === QuestionTypes.Numeric_Tally}
						allowLeadingZero={this.state.Allow_Leading_Zero}
						onAllowLeadingZeroChange={this.handleAllowLeadingZeroChange}
						Widget_ID={Widget_ID}
						remapResponses={remapResponses}
						setRemapResponses={this.setRemapResponses}
					/>
				)}

				{/* Video */}
				{Question_Type_ID === QuestionTypes.Video &&
					<TypeVideo onSave={this.handleSave} onRemove={this.handleRemove}
							   Question_ID={this.state.Question_ID}/>}

				{/* multiple choice */}
				{Question_Type_ID === QuestionTypes.Multiple_Choice &&
					<TypeMultiChoice onSave={this.handleSave} onRemove={this.handleRemove}
									 Question_ID={this.state.Question_ID} Widget_ID={this.state.Widget_ID}
									 onMultipleSelection={this.handleAllowMultipleSelection}
									 remapResponses={remapResponses}
									 setRemapResponses={this.setRemapResponses}/>}

				{/* picklist */}
				{Question_Type_ID === QuestionTypes.Picklist &&
					<TypePicklist Project_ID={Project_ID} Custom_Render={Custom_Render} onSave={this.handleSave}
								  onRemove={this.handleRemove} Question_ID={this.state.Question_ID}
								  Widget_ID={Widget_ID}
								  remapResponses={remapResponses}
								  setRemapResponses={this.setRemapResponses}/>}

				{/* Matrix */}
				{Question_Type_ID === QuestionTypes.Matrix && (
					<TypeMatrix Widget_ID={this.props.Widget.Widget_ID} Custom_Render={Custom_Render}
								onSave={this.passDown} onRemove={this.handleRemove}
								onSuccessfulSave={this.handleCanChangeType} Question_ID={this.state.Question_ID}
								remapResponses={remapResponses}
								setRemapResponses={this.setRemapResponses}/>
				)}

				{/* Scale Question */}
				{Question_Type_ID === QuestionTypes.Scale &&
					<TypeScale onSave={this.handleSave} onRemove={this.handleRemove}
							   Widget_ID={Widget_ID}
							   Question_ID={this.state.Question_ID}
							   remapResponses={remapResponses}
							   setRemapResponses={this.setRemapResponses}/>
				}

				{/* Dropdown */}
				{Question_Type_ID === QuestionTypes.Dropdown && (
					<TypeDropdown
						onSave={this.handleSave}
						// onSave={this.passDown}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						Widget_ID={this.state.Widget_ID}
						onMultipleSelection={this.handleAllowMultipleSelection}
						allowMultipleSelection={this.state.Allow_Multiple_Selection}
						remapResponses={remapResponses}
						setRemapResponses={this.setRemapResponses}
					/>
				)}

				{/* Institution */}
				{Question_Type_ID === QuestionTypes.Institution && (
					<TypeInstitution
						onSave={this.handleSave}
						// onSave={this.passDown}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						Widget_ID={this.state.Widget_ID}
						onMultipleSelection={this.handleAllowMultipleSelection}
						allowMultipleSelection={this.state.Allow_Multiple_Selection}
						remapResponses={remapResponses}
						setRemapResponses={this.setRemapResponses}
					/>
				)}

				{Number.isNaN(Question_Type_ID) && (
					<div className='float-right mt-2'>
						<button className='btn btn-outline-danger' onClick={this.handleRemove}>
							Delete
						</button>
					</div>
				)}
				<ToastContainer />
			</React.Fragment>
		);
	}
}

export default WQuestionAnswer;
